module.exports = __webpack_public_path__ + "img/Vessel_Information.0cf1847d.png";